import { observer } from 'mobx-react-lite'
import { AddressFields } from './fields/AddressFields'
import { BusinessDetailsFields } from './fields/BusinessDetailsFields'

import styles from './styles.module.scss'

export const ManualBusinessForm = observer(() => (
  <div className={styles.form}>
    <AddressFields />
    <BusinessDetailsFields />
  </div>
))
